// GoogleMapsWrapper.js
import React, { useState, useEffect } from "react";

const GoogleMapsWrapper = ({ children }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (window.google) {
      setIsLoaded(true);
    } else {
      const interval = setInterval(() => {
        if (window.google) {
          clearInterval(interval);
          setIsLoaded(true);
        }
      }, 100);
      return () => clearInterval(interval);
    }
  }, []);

  return isLoaded ? children : <div>Loading Google Maps...</div>;
};

export default GoogleMapsWrapper;